import React from 'react';
import { useNavigate } from '@tanstack/react-router';
import {
    LayoutDashboard,
    Home,
    BarChart,
    List,
    FileText,
    Utensils,
    TrendingUp,
    Bell,
    Tag,
    Scale,
    Settings
} from "lucide-react";
import { useRegisterCommandDefinitions } from '../contexts/CommandRegistryContext';
import { defineCommands } from '../utils/commands';

export function GlobalCommands() {
    const navigate = useNavigate();

    const commandDefinitions = React.useMemo(() => defineCommands([
        // Suggestions
        {
            id: 'dashboard',
            labelKey: 'dashboard.label',
            descriptionKey: 'dashboard.description',
            namespace: 'commands',
            group: 'Suggestions',
            icon: <LayoutDashboard className="mr-2 h-4 w-4" />,
            action: () => navigate({ to: "/dashboard" }),
            keywords: ['dashboard', 'irányítópult', 'overview']
        },
        {
            id: 'home',
            labelKey: 'home.label',
            descriptionKey: 'home.description',
            namespace: 'commands',
            group: 'Suggestions',
            icon: <Home className="mr-2 h-4 w-4" />,
            action: () => navigate({ to: "/home" }),
            keywords: ['home', 'kezdőlap']
        },
        {
            id: 'analytics',
            labelKey: 'analytics.label',
            descriptionKey: 'analytics.description',
            namespace: 'commands',
            group: 'Suggestions',
            icon: <BarChart className="mr-2 h-4 w-4" />,
            action: () => navigate({ to: "/analytics" }),
            keywords: ['analytics', 'elemzések', 'reports']
        },
        // Finance
        {
            id: 'cost-reports',
            labelKey: 'costReports.label',
            descriptionKey: 'costReports.description',
            namespace: 'commands',
            group: 'Finance',
            icon: <FileText className="mr-2 h-4 w-4" />,
            action: () => navigate({ to: "/cost-reports" }),
            keywords: ['cost', 'reports', 'költség', 'jelentések']
        },
        {
            id: 'profit-loss',
            labelKey: 'profitLoss.label',
            descriptionKey: 'profitLoss.description',
            namespace: 'commands',
            group: 'Finance',
            icon: <TrendingUp className="mr-2 h-4 w-4" />,
            action: () => navigate({ to: "/profit-loss" }),
            keywords: ['profit', 'loss', 'eredmény', 'nyereség']
        },
        // Inventory
        {
            id: 'ingredients',
            labelKey: 'ingredients.label',
            descriptionKey: 'ingredients.description',
            namespace: 'commands',
            group: 'Inventory',
            icon: <Utensils className="mr-2 h-4 w-4" />,
            action: () => navigate({ to: "/ingredients" }),
            keywords: ['ingredients', 'alapanyagok']
        },
        {
            id: 'categories',
            labelKey: 'categories.label',
            descriptionKey: 'categories.description',
            namespace: 'commands',
            group: 'Inventory',
            icon: <List className="mr-2 h-4 w-4" />,
            action: () => navigate({ to: "/categories" }),
            keywords: ['categories', 'kategóriák']
        },
        {
            id: 'units',
            labelKey: 'units.label',
            descriptionKey: 'units.description',
            namespace: 'commands',
            group: 'Inventory',
            icon: <Scale className="mr-2 h-4 w-4" />,
            action: () => navigate({ to: "/units" }),
            keywords: ['units', 'mértékegységek']
        },
        {
            id: 'tags',
            labelKey: 'tags.label',
            descriptionKey: 'tags.description',
            namespace: 'commands',
            group: 'Inventory',
            icon: <Tag className="mr-2 h-4 w-4" />,
            action: () => navigate({ to: "/tags" }),
            keywords: ['tags', 'címkék']
        },
        // Settings
        {
            id: 'settings',
            labelKey: 'settings.label',
            descriptionKey: 'settings.description',
            namespace: 'commands',
            group: 'Settings',
            icon: <Settings className="mr-2 h-4 w-4" />,
            shortcut: '⌘S',
            action: () => navigate({ to: "/settings" }),
            keywords: ['settings', 'beállítások']
        },
        {
            id: 'notifications',
            labelKey: 'notifications.label',
            descriptionKey: 'notifications.description',
            namespace: 'commands',
            group: 'Settings',
            icon: <Bell className="mr-2 h-4 w-4" />,
            action: () => navigate({ to: "/notifications" }),
            keywords: ['notifications', 'értesítések']
        }
    ]), [navigate]);

    useRegisterCommandDefinitions(commandDefinitions);

    return null;
}
